import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, BooleanColumn, TextColumn} from '../../../../shared/Models/columns';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BackOfficeInvoiceService} from '../../../Services/invoice.service';
import {DealersService} from '../../../Services/dealers.service';
import {SupplierService} from '../../../Services/supplier.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Invoice} from '../../../Models/Invoice';
import {CreditInvoiceService} from '../../../Services/creditInvoice.service';
import {Helper} from '../../../../helpers/helper.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import {CreditInvoiceItem} from '../../../Models/CreditInvoiceItem';
import {IButton} from '../../../../shared/card/card.component';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';


@Component({
  selector: 'app-backoffice-draft-invoice-overview',
  templateUrl: './backoffice-draft-invoice-overview.component.html',
  styleUrls: ['./backoffice-draft-invoice-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class BackofficeDrafyInvoiceOverviewComponent implements OnInit {
  public invoiceId: number;
  public isPartialPaid = false;
  public isEditPartialPaid = false;
  public partialPaid: string;
  public invoice = new Invoice();
  public grid: Grid;
  public isEdit = false;
  public creditInvoiceItems: CreditInvoiceItem[];
  public headerButtons;
  public specialButtons: IButton[] = [];
  public params;
  public templates;
  public disableCreditInvoiceBtn = false;
  selectedTemplate;
  public dateFormat;
  @ViewChild('amountPriceTemp', {static: true}) amountPriceTemp;
  @ViewChild('draftInvoiceDealer', {static: true}) draftInvoiceDealer;
  @ViewChild('amountExPriceTemp', {static: true}) amountExPriceTemp;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('creditInvoiceModal', {static: false}) creditInvoiceModal = null;
  @ViewChild('createCustomInvoiceModal', {static: false}) createCustomInvoiceModal = null;
  @ViewChild('statusTemplate', {static: true}) statusTemplate;
  @ViewChild('dueDateTemplate', {static: true}) dueDateTemplate;
  @ViewChild('addCreditInvoiceForm', {static: false}) addCreditInvoiceForm;
  @ViewChild('addCreateCustomInvoiceForm', {static: false}) addCreateCustomInvoiceForm;

  constructor(
    private readonly invoiceService: BackOfficeInvoiceService,
    private readonly router: Router,
    private readonly translator: TranslateService,
    private readonly dealersService: DealersService,
    private readonly broadcastService: BroadcastService,
    private readonly helper: Helper,
    private readonly auth: AuthenticationService,
    private readonly invoiceLayoutService: InvoiceLayoutService) {
  }

  ngOnInit() {
    this.headerButtons = [
      {
        name: this.translator.instant('admin.order.custom_invoice.button_title'),
        btnIcon: 'fa fa-plus',
        method: 'openGenerateInvoiceModal',
        customClass: 'btn btn-grey btn-outline-primary ripple light'
      },
    ];
    this.headerButtons.forEach(items => {
      this.specialButtons.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });

    this.dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <BooleanColumn>{
          type: BooleanColumn.type,
          sortable: false,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.date',
          prop: 'createdAt',
          sortable: false,
          type: TextColumn.type,
          minWidth: 100,
          maxWidth: 140,
          translate: true,
          valueFormatter: row => moment(row).format(this.dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_number',
          prop: 'id',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_dealer',
          prop: 'companyName',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
          valueTemplate: this.draftInvoiceDealer,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.amount_inc',
          prop: 'amount',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
          valueTemplate: this.amountPriceTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.amount_ex',
          prop: 'amountEx',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
          valueTemplate: this.amountExPriceTemp,
        },
        <TextColumn>{
          name: 'doctrine.invoice.type',
          prop: 'type',
          sortable: false,
          type: TextColumn.type,
          width: 200,
          maxWidth: 300,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: (row) => this.router.navigateByUrl('back-office/invoice/draft/show/' + row.id ),
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.invoiceService,
      rememberURL: this.router.url,
      method: 'getDraftInvoices',
      root: 'data',
      defaultSort: 'created',
      bulkActionMethod: 'invoiceBulkAction',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: false,
      doseNotHaveSearch: true,
      multipleRowSearch: false,
      showIsCreditCheckbox: false,
      search: [
        <GridSearchItem>{
          hasCalendar: false,
          hasInvoiceStatus: false,
          hasBackofficeDropdownListFilter: false,
          hasNormalSearch: true,
        }
      ],
    };

    this.invoiceLayoutService.getActiveLayoutList(true).subscribe(res => {
      this.templates = [];
      res.data.map(template => {
        this.templates.push({
          label: template.name,
          value: template.id,
        });
      });
      this.selectedTemplate = this.templates[0] ? this.templates[0].value : null;
    });

  }

  openCreditInvoiceModal(invoice, isEdit) {
    this.creditInvoiceItems = JSON.parse(JSON.stringify(invoice.creditInvoiceItems));
    if (invoice.invoiceLayout) {
      this.selectedTemplate = invoice.invoiceLayout.id;
    }
    if (!isEdit) {
      this.addCreditItem();
    }
    this.isEdit = isEdit;
    this.creditInvoiceModal.show();
    this.invoiceId = invoice.id;
  }

  addCreditItem() {
    this.creditInvoiceItems.push(new CreditInvoiceItem());
  }

  removeCreditItem(creditInvoiceItemIndex) {
    this.creditInvoiceItems.splice(creditInvoiceItemIndex, 1);
    this.creditInvoiceItems = JSON.parse(JSON.stringify(this.creditInvoiceItems));
  }

  onCredit() {
    this.disableCreditInvoiceBtn = true;
    const creditInvoice = new Invoice();
    creditInvoice.creditInvoiceItems = this.creditInvoiceItems;
    creditInvoice.invoiceLayout = this.selectedTemplate;
    delete creditInvoice.creditInvoices;
    this.invoiceService.creditInvoice(creditInvoice, this.invoiceId, this.isEdit).subscribe(() => {
      this.disableCreditInvoiceBtn = false;
      this.creditInvoiceModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getInvoices');
      let message = 'admin.backoffice.invoice.overview.credit_success';
      if (this.isEdit) {
        message = 'admin.backoffice.invoice.overview.credit_update_success';
      }

      this.helper.popMessageDialog(
        this.translator.instant('global.success_message.title'),
        this.translator.instant(message),
        'success',
        false
      );
    });
  }

  hideModal() {
    this.creditInvoiceModal.hide();
  }


  calculateOverdueDays(date) {
    let now = moment();
    now = moment(now, 'YYYY/MM/DD');
    const dueDate = moment(date, 'YYYY/MM/DD');
    return now.diff(dueDate, 'days');
  }

  setParams(event) {
    this.params = event;
  }

  callFunction(method) {
    this[method]();
  }

  openGenerateInvoiceModal() {
    this.createCustomInvoiceModal.showDialog();
  }

  onInvoiceGenerated(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getInvoices');
    }
  }

  formatDateString(date) {
    return moment(date).format(this.dateFormat);
  }
}
